export default "__VITE_ASSET__yqqg$Gi0__"